import { render } from "./supportForm.vue?vue&type=template&id=c21fd6a6&scoped=true"
import script from "./supportForm.vue?vue&type=script&lang=js"
export * from "./supportForm.vue?vue&type=script&lang=js"

import "./supportForm.vue?vue&type=style&index=0&id=c21fd6a6&scoped=true&lang=css"
import "./supportForm.vue?vue&type=style&index=1&id=c21fd6a6&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp_form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21fd6a6"]])

export default __exports__